<template>

  <ModalPodcastLayout :closeModal="closeInfosModal">

    <div class="video-info-container">
      <div id="genral-information" class="p-2">
        <div class="general-info-wrapper">
          <div class="">
                      <MainInfo :information="information"/>

          </div>
        </div>
        <div class="description">
         {{information.infoOptions.description}}
        </div>
      </div>
    </div>

  </ModalPodcastLayout>

</template>

<script>
import MainInfo from './Sections/MainInfo/MainInfo.vue';

import ModalPodcastLayout from '../../layout/ModalPodcastLayout/ModalPodcastLayout.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'video-information',
  components: {
    ModalPodcastLayout,
    MainInfo,
  },
  props: {
    information: {
      type: Object,
      required: true,
    },
    closeInfosModal:{
      type:Function
    },
       duration: {
      type: String,
      required: true,
    },
    
  },
  data() {
    return {
      isOpen: false,
      nb_stats_views: 0,
    };
  }


});
</script>

<style>
@import './InfosModal.css';
</style>
